<template>
  <div id=bac>
    <mt-header title="实名认证">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
      <mt-button slot="right" @click="next">下一步</mt-button>
    </mt-header>

    <!-- <div>
      <img id="reminderImg" src="/static/img/user/approval/reminder.png"/>
      <div id="remindMsg" class="remindMsg">
        此版只支持个人用户,企业用户请到电脑端进行认证
      </div>
    </div> -->
    <div>
      <mt-field label="姓名" placeholder="请输入真实姓名" v-model="realName" :disabled="attestation=='8'? true: false"></mt-field>
      <mt-field label="身份证号码" @blur="validateIdCardIsExist()" @mouseout="validateIdCardIsExist()"
                placeholder="请输入身份证号码" v-model="userCardId" :disabled="attestation=='8'? true: false"></mt-field>
      <mt-field label="设置签署密码" type="password" placeholder="请设置六位签署密码" v-model="signCord"></mt-field>
    </div>


  </div>

</template>
<script>
  import {Toast, Actionsheet, Field, Indicator} from 'mint-ui';
  import cheader from '@/components/header';
  import qs from "qs";
  var Base64 = require('@/js/base64.js')

  export default {
    name: 'approval',
    data () {
      return {
        signCord: "",
        realName: "",
        userCardId: "",
        _router: "",
        _selected: "",
        validateIdCardIsExistResult: false,
        attestation:'',
      }
    },
    methods: {
      next () {
        var flag = this.valiateData(); // 验证输入框
        if (!flag) {
          return;
        }
      var that = this;
      that.$http.post(
          domain("_setSignCode"),
          {
            'signCode':$.md5(this.signCord)
          }
          )
          .then(function (response) {
            console.log(response);
            //接口返回数据,
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              let queryData={
                  username: this.realName,
                  userCardId: this.userCardId,
                  signCode: this.signCord,
                  _selected: this._selected,
                  attestation:this.attestation,
              }
              const queryString = qs.stringify(queryData);
              const objBase64 = new Base64.Base64();
              const approvalInfo = objBase64.encode(queryString);
              this.$router.push({
                  path: '/user/bankApproval',
                  query: {
                    approvalInfo,
                  }
              })
            } else {
              Toast({
                message: msg
              });
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
	    
      },
      getParams(){
        // let params = this.$route.query;
        // this._router = params._router;
        // this._selected = params._selected;
        let queryData = this.$route.query;
        if(queryData.approvalInfo){
            let objBase64 = new Base64.Base64();
            let params =qs.parse(objBase64.decode(queryData.approvalInfo));
            this.signCord= params.signCode;
            this.realName= params.username;
            this.userCardId= params.userCardId;
            this._selected = params._selected;
            this.attestation=params.attestation;
        }
      },
      goBack: function () {
        this.$router.push({
          path: '/main',
          name: 'main',
          query: {}
        })
      },
      valiateData: function () {
        if (this.realName == "" || typeof(this.realName) == "undefined" || this.realName.trim()=="") {
          Toast("请输入姓名");
          return false;
        }
        // var cert_nameReg = /^[a-zA-Z.\u4E00-\u9FA5]{2,16}$/;

        if (this.realName.trim().length>16 || this.realName.trim().length<2) {
          Toast("姓名为2-16个字符");
          return false;
        }
        if (this.userCardId == "" || typeof(this.userCardId) == "undefined") {
          Toast("请输入身份证证件号");
          return false;
        }
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
	    if(reg.test(this.userCardId) === false){  
		   Toast("身份证证件号不合法");
	       return false;  
	    }  				
        
		if (this.signCord == "" || typeof(this.signCord) == "undefined") {
          Toast("请输入签署密码");
          return false;
        }
        var sc = this.signCord;
        if (sc.length != 6) {
          Toast("签署密码为6位数字.");
          return false;
        } else {
          var reg = /^\d{6}$/;
          if (!reg.test(sc)) {
            Toast("签署密码为6位数字.");
            return false;
          }
        }
        return true;
      },
      fetcchMsg: function () {
        let that=this;
        var _mainIndex_Url = domain("_mainIndex"); //个人中心数据
        this.$http.post(
          _mainIndex_Url,
          {emulateJSON: true}
          )
          .then(function (response) {
            console.log(response);
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              var returnDate = response.data.data;
              that.realName= returnDate.name;
              that.userCardId= returnDate.idCard;
              that.attestation=returnDate.approveStatus;
            } else {
              Toast(msg)
            }
          }, function (error) {
            console.log(error);
          }).catch(function (response) {
            console.log(response);
        })
      },
    },
    components: {
      cheader
    },
    created: function () {
      this.getParams();
      this.fetcchMsg();
    }
  }
</script>
<style>
  #bac {
    position: fixed;
    height: 100%;
    background-color: #ECECEC;
    width: 100%;
  }

  .remindMsg {
    font-size: 0.8rem;
    color: #c1c1c1;
    line-height: 2rem;
  }

  #reminderImg {
    width: 15px;
    height: 15px;
    float: left;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    padding-right: 0.5rem;
  }

  #bac .mint-cell-text {
    color: #7d7d7d;
  }
  input:disabled{
    background:none;
    color:#999;
  }
</style>



// WEBPACK FOOTER //
// src/module/user/approval.vue